import styled from 'styled-components';

const BannerWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .banner-ad--link {
    width: 100%;
    margin: 0 20px;

    img {
      width: 100%;
      border-radius: 10px;
    }
  }

  @media (max-width: 1283px) {
    margin: 0 45px 44px;
  }

  @media (max-width: 991px) {
    .banner-ad--link {
      margin: 0 10px;
    }
  }

  @media (max-width: 576px) {
    margin: 0 0 44px;
    padding: 0 20px;
  }
`;

export { BannerWrapper };
